/* eslint-disable complexity */
import React from "react";

import { useCountriesOrRegionsList } from "../../../../helpers/countriesOrRegionsList";
import { DropdownOption } from "../../../../helpers/optionSets";
import { IdAzureIntroContactDataType } from "../../../../models/forms";
import { ReadOnlyFormItem } from "../appInfoModelsAndHelpers";
import { ReadOnlyForm } from "../ReadOnlyForm";

type DefaultIntroContactConfigDataType = IdAzureIntroContactDataType;

type ReadOnlyContactAndStudioProps = {
  dataInForm: DefaultIntroContactConfigDataType;
};

const ReadOnlyContactAndStudioConfig: Map<string, ReadOnlyFormItem> = new Map([
  ["firstName", {}],
  ["lastName", {}],
  ["businessTitle", {}],
  ["email", {}],
  ["studioName", { title: "companyName" }],
  ["businessName", { title: "legallyRegisteredBusinessName" }],
  ["studioWebsite", {}],
  ["gameplayVideoLinks", { title: "supportingDocuments" }],
  [
    "countryOrRegion",
    {
      mapper: (
        data: DefaultIntroContactConfigDataType,
        _localizedStrings: Map<string, string>,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        additionalData?: Map<string, any>
      ) => {
        if (!additionalData) {
          return null;
        }
        const countriesOrRegionsList = additionalData.get(
          "countriesOrRegionsList"
        ) as Array<DropdownOption>;
        const selectedCountryCode = data.countryOrRegion;
        for (const country of countriesOrRegionsList) {
          if (country.value === selectedCountryCode) {
            return country.label;
          }
        }
        return selectedCountryCode;
      },
    },
  ],
  [
    "address",
    {
      mapper: (data: DefaultIntroContactConfigDataType) =>
        `${data.addressLine1} </br> ${data.addressLine2}`,
      isAnswerWithHtmlContent: true,
    },
  ],
  ["city", {}],
  ["stateRegion", {}],
  ["postalCode", {}],
  ["phone", {}],
]);

export const ReadOnlyContactAndStudio = ({ dataInForm }: ReadOnlyContactAndStudioProps) => {
  const countriesOrRegionsList = useCountriesOrRegionsList();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const additionalData = new Map<string, any>([["countriesOrRegionsList", countriesOrRegionsList]]);
  return (
    <ReadOnlyForm
      formConfig={ReadOnlyContactAndStudioConfig}
      formData={dataInForm}
      additionalData={additionalData}
    />
  );
};
